exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".detail-accordion .expansion-panel__container--active{margin-bottom:15px!important}@media only screen and (max-width:500px){.detail-accordion .list__tile__action{display:none}.detail-accordion .list__tile__avatar{margin-left:-20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37711cea","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DetailAccordion.vue
// module id = 405
// module chunks = 0